import {
  Box,
  HeadingText,
  StackLayout,
  Button,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { MAX_CONTENT_WIDTH } from 'common/ui';
import { useIsBelowTablet } from 'hooks/use-is-below-tablet/use-is-below-tablet.hook';

interface PageHeaderProps {
  text: string;
  historyGoBack?: boolean;
  onBackClick?: () => void;
}

const BACK_BUTTON_WIDTH = 125;

export const PageHeader = ({
  text,
  onBackClick,
  historyGoBack = false,
}: PageHeaderProps) => {
  const isBelowTablet = useIsBelowTablet();
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  const showBackButton = Boolean(historyGoBack || onBackClick);

  return (
    <Box
      css={{
        backgroundColor: '$surfaceScreenHeaderBackground',
        height: isBelowTablet ? 96 : 140,
        paddingInline: '$two',
        marginBlockEnd: '$two',
      }}
    >
      <StackLayout
        orientation="horizontal"
        verticalAlignment="center"
        css={{
          maxWidth: showBackButton
            ? MAX_CONTENT_WIDTH + BACK_BUTTON_WIDTH
            : MAX_CONTENT_WIDTH,
          marginInline: 'auto',
          height: '100%',
        }}
      >
        {showBackButton && (
          <Button
            onClick={
              onBackClick ||
              (() => {
                navigate(-1);
              })
            }
            quiet
            priority="tertiary"
            icon="interfaceArrowLeft"
            size="medium"
            hideLabel
            css={{ marginInlineEnd: '$oneAndHalf' }}
          >
            {formatMessage({ id: 'STR_GO_BACK' })}
          </Button>
        )}
        <HeadingText
          level="1"
          size={isBelowTablet ? 'xl' : 'xxl'}
          // The current typeface has a built-in line height, so it needs to be pushed down to be centred in the parent container. Revisit if the typeface changes.
          css={{ paddingBlockStart: 6 }}
        >
          {text}
        </HeadingText>
      </StackLayout>
    </Box>
  );
};
